/*global page, FakeCation, FB */
(function (fc) {
  "use strict";
  var pages = FakeCation.pages;
  var currentPage = null;

  var pageSections = document.querySelectorAll('section[data-component="page"]');

  function showPage(element) {
    var i, l = pageSections.length,
      page, selectedPage;

    for (i = 0; i < l; i++) {
      page = pageSections.item(i);
      page.dataset.selected = "";
      if (page === element) {
        selectedPage = page;
      }
    }
    if (selectedPage) {
      selectedPage.dataset.selected = "selected";
    }
  }


  fc.appState = {
    base: '/index.html',
    selfieImage: null,
    background: null
  };

  page.base('/');

  page('*', function (ctx, next) {
    var newPage;

    if (ctx.init) {
      page.redirect('/welcome');
    } else {

      console.log(ctx);
      newPage = fc.pageManager.getByName(ctx.pathname.split('/')[1]);
      if (newPage) {
        newPage.render();
        showPage(newPage.sectionElement);
        currentPage = newPage;
        newPage.bind(ctx);
        newPage.run(ctx,next);
      } else {
        page.redirect('/welcome');
      }
    }
  });


  page({
    hashbang: true
  });

  window.fbAsyncInit = function () {
    FB.init({
      appId: '1669312666685444',
      xfbml: true,
      version: 'v2.5'
    });
    console.log('fb inited');
  };

  (function (d, s, id) {
    var js, fjs = d.getElementsByTagName(s)[0];
    if (d.getElementById(id)) {
      return;
    }
    js = d.createElement(s);
    js.id = id;
    js.src = "//connect.facebook.net/en_US/sdk.js";
    fjs.parentNode.insertBefore(js, fjs);
  }(document, 'script', 'facebook-jssdk'));

}(FakeCation));
